import * as React from 'react'
import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax'
import { centered } from './hero.module.scss'
import { narrowScreen } from './../../assets/scss/variables.module.scss'
import { StaticImage } from 'gatsby-plugin-image'
import './../../style.scss'
import { Container } from '@mui/material'

/**
 * Component Name: Hero
 * Description: Parallax banner based on react-scroll-parallax
 *
 * Prop list:
 * imageUrl => url of background image
 * id => Unique id of the section
 * bgColor => color of overlay - do not use for no overlay
 * bgOpacity => opacity of overlay - do not use if no overlay
 * txtColor => color of text inside (children)
 *
 * Accepts children for text inside banner
 *
 */

const HeroVideos = ({
  id,
  imageUrl,
  size,
  bgColor,
  bgOpacity,
  txtColor,
  children,
  //copyright
}) => {
  // const bannerHeightHalf = {
  //   minHeight: '400px',
  //   height: '50vh',
  //   maxHeight: '500px'
  // }

  // const bannerBody = {
  //   maxWidth: narrowScreen,
  //   margin: 'auto'
  // }
  // const overlay = {
  //   width: '100%',
  //   height: '100%',
  //   backgroundColor: bgColor,
  //   opacity: bgOpacity ? bgOpacity : '0'
  // }
  // const textColor = {
  //   color: txtColor ? txtColor : '#000000'
  // }
  // const posAbs = {
  //   position: 'absolute',
  //   bottom: '20px',
  //   right: '20px'
  // }
  // let copyArr = ''
  // if (copyright != '') {
  //   copyArr = copyright.split(' ©');
  // }

  return (
    <Container className='videosection' maxWidth='false' style={{ 
    backgroundColor: '#0a3758', 
    backgroundImage:' url('+imageUrl+')', 
    backgroundRepeat:'no-repeat',  
    backgroundBlendMode: 'luminosity', 
    backgroundPosition:'center center',
    backgroundSize: 'cover',
  
  }}><div className='pt-1 pb-5'>{children}</div></Container>
  )
}

export default HeroVideos

